export default __webpack_public_path__ + "static/4-4b07243478b60abaf0ed0bd70b06b984.jpeg";